export const TEST_ID = 'activityHeaderText';
